import { IAnyPlan } from '@belong/types';

// Returns the plan speed analytics need
export const getAnalyticsPlanSpeed = (plan: IAnyPlan): string | undefined => {
  if (plan.data) {
    return `${plan.data.value}${plan.data.unit}`;
  }
  if (plan.networkSpeed) {
    return `${plan.networkSpeed.downstream.value}${plan.networkSpeed.downstream.unit}`;
  }
  return undefined;
};
